import { render, staticRenderFns } from "./modifiedData.vue?vue&type=template&id=42a31635&"
import script from "./modifiedData.vue?vue&type=script&lang=js&"
export * from "./modifiedData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports